<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BffALw/tc-custom/9781466818682.jpg?1721099582470" alt="This image is the cover for the book Ship of Dreams, Dreamlands"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ship of Dreams, Dreamlands
      </h1>
      <p class="bookDescription body article font2">
        <b>From the Bram Stoker Award–winning author, two heroes face a zombie army and more terrors in this fantasy adventure set in the world of H. P. Lovecraft.</b><br/><br/>Once David Hero was an ordinary man living in the real world. Now he is trapped in the Dreamlands, cut off from the waking world. David Hero’s dreams and nightmares have become his only reality . . . <br/><br/>Led by wickedly beautiful Queen Zura, the zombie armies of the dead are on the march. They will destroy the beautiful Dreamlands, making them a permanent, deadly nightmare.<br/><br/>Unaware of the marauding zombies, David Hero and his friend Eldin voyage through the clouds in a wondrous skyship. Their journey is interrupted by a pack of faceless nightgaunts, terrifying creatures, half-man and half-bat—and all evil!<br/><br/>David Hero is one of Zura’s first targets. As a man of the waking world, he can withstand her terrible seductive power and shatter her shambling armies. David Hero must be the first Dreamlands hero to die . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brian Lumley
      </h2>
      
      <p class="authorDescription body article"><P><B>Brian Lumley</B> is the author of the bestselling Necroscope series of vampire novels.  The first <I>Necroscope</I>, Harry Keogh, also appears in a collection of Lumley's short fiction, <I>Harry Keogh and Other Weird Heroes</I>, along Titus Crow and Henri Laurent de Marigny, from T<I>itus Crow, Volumes One, Two, and Three</I>, and <I>David Hero and Eldin the Wanderer</I>, from the<I> Dreamlands</I> series. <br><br>An acknowledged master of Lovecraft-style horror, Brian Lumley has won the British Fantasy Award and been named a Grand Master of Horror.  His works have been published in more than a dozen countries and have inspired comic books, role-playing games, and sculpture, and been adapted for television.<br><br>When not writing, Lumley can often be found spear-fishing in the Greek islands, gambling in Las Vegas, or attending a convention somewhere in the US.  Lumley and his wife live in England.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6ebad434